module.exports = __webpack_public_path__ + "7df7f0ecc8b7696b2860741df5133c6a.jpg";